module.exports = __webpack_public_path__ + "static/self-image-789e27bf0d9fcaa9f926de308a9dfc6b.jpg";